import styled from "styled-components";

export default styled.div`
  margin-bottom: 50px;
  .header__text {
    color: rgba(0, 0, 0, 0.87);
    margin-bottom: 25px;
    position: relative;
    color: black;
    font-size: 25px;
    &::after {
      content: "";
      position: absolute;
      height: 1px;
      width: 60px;
      background-color: ${(props) => props.theme.colors.primary.main};
      bottom: -5px;
      left: 0px;
    }
  }

  .recommended__wrapper {
    .video-detail-recommendations {
      display: flex;
      margin-bottom: 10px;
      .imgthumb {
        max-width: 180px;
        height: 100px;

        .image-container {
          width: 180px;
          height: 100px;

          .video-thumbnail-container {
            height: 100px;
          }
          .itemoverlay {
            width: 180px;
            transform: translate3d(0, 0, 0);
            height: 0;
            transition: all 0.35s;
          }

          &:hover {
            .itemoverlay {
              height: 26px;
              transition: all 0.35s;
            }
          }
        }
        img.thumb-vid {
          width: 100%;
          height: 100px;
        }
      }
      .itemTitle {
        margin-left: 15px;
        a {
          h3 {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.87);
            font-weight: 400;
          }
          p {
            font-size: 12px;
          }
        }
      }
    }
  }

  .search-result {
    margin: 0;
    padding: 0 30px 50px;

    p {
      font-weight: 400;
      font-size: 12px;
      text-align: left;
    }
  }

  .recommend-result {
    padding-bottom: 0 !important;
  }

  .recommendations-container {
    margin: 20px auto;
    width: 100%;

    .carousel-inner {
      width: 100%;
      margin: 0 auto;
      min-height: 230px;
      max-width: 1300px;

      .row {
        justify-content: center;
      }
    }

    .itemTitle {
      background: #fff;
      h3 {
        font-size: 16px;
        text-transform: none;
        font-weight: 400;
        letter-spacing: 0;
      }
      p {
        font-size: 14px;
      }
    }

    .itemoverlay {
      bottom: 0;
    }

    #most-recent-container1 .itemTitle,
    #video-box-template .itemTitle,
    .fav-item .itemTitle,
    .recommend-result .itemTitle {
      background: #fff;
    }

    .recommendations-control {
      width: 100%;

      .recommend-left,
      .recommend-right {
        background: #bababa;
        color: #fff;
        padding: 15px 8px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);

        &:hover {
          background: #e0331a;
        }
      }

      .recommend-left {
        left: -50px;
      }

      .recommend-right {
        right: -50px;
      }
    }

    .recommendations-control i {
      font-weight: 700;
      font-size: 22px;
    }

    .video-detail-recommendations {
      &:hover {
        a {
          h3 {
            color: ${(props) => props.theme.colors.primary.main}
          }
        }
      }
    }
  }

  .view__more {
    width: 300px;
    margin-top: 30px;
    &:hover {
      background-color: rgba(0, 0, 0, 0.04);
    }
  }

  @media screen and (max-width: 991px) {
    padding-bottom: 50px;
    margin-bottom: unset;
    position: relative;
    .recommended__wrapper {
      .video-detail-recommendations {
        .imgthumb {
          width: 100px;
          height: 56px;
          .image-container {
            width: 100px;
            height: 56px;
            .video-thumbnail-container {
              height: 56px;
            }
            &:hover {
              .itemoverlay {
                display: none;
              }
            }
          }
          img.thumb-vid {
            width: 100%;
            height: 56px;
          }
        }
        .itemTitle {
          h3 {
            padding-top: 0 !important;
            margin-bottom: 5px !important;
            height: 33px !important;
            font-size: 12px !important;
          }

          .date__clearance {
            line-height: 25px;
            font-size: 11px;
            color: #9d9d9d;
          }
        }
      }
    }

    .view__more {
      position: absolute;
      right: 0;
      bottom: 0;
      width: auto;
      border: unset;
      font-size: 12px;
    }
  }

  @media screen and (min-width: 992px) and (max-width: 1230px) {
    .recommended__wrapper {
      .video-detail-recommendations {
        display: flex;
        margin-bottom: 10px;
        .imgthumb {
          max-width: 150px;
          height: 80px;

          .image-container {
            width: 150px;
            height: 80px;

            .video-thumbnail-container {
              height: 80px;
            }
            .itemoverlay {
              width: 150px;
              transform: translate3d(0, 0, 0);
              height: 0;
              transition: all 0.35s;
            }

            &:hover {
              .itemoverlay {
                height: 26px;
                transition: all 0.35s;
              }
            }
          }
          img.thumb-vid {
            width: 100%;
            height: 80px;
          }
        }
        .itemTitle {
          .date__clearance {
            & > span:first-child {
              display: none;
            }
          }
        }
      }
    }
  }
`;
